export const CREATE_PROJECT_REQUEST = "CREATE_PROJECT_REQUEST";
export const CREATE_PROJECT_REQUEST_SUCCESS = "CREATE_PROJECT_REQUEST_SUCCESS";
export const CREATE_PROJECT_REQUEST_FAILED = "CREATE_PROJECT_REQUEST_FAILED";

export const FETCH_PROJECTS_REQUEST = "FETCH_PROJECTS_REQUEST";
export const FETCH_PROJECTS_REQUEST_SUCCESS = "FETCH_PROJECTS_REQUEST_SUCCESS";
export const FETCH_PROJECTS_REQUEST_FAILED = "FETCH_PROJECTS_REQUEST_FAILED";

export const DELETE_PROJECT_REQUEST = "DELETE_PROJECT_REQUEST";
export const DELETE_PROJECT_REQUEST_SUCCESS = "DELETE_PROJECT_REQUEST_SUCCESS";
export const DELETE_PROJECT_REQUEST_FAILED = "DELETE_PROJECT_REQUEST_FAILED";

export const FETCH_PROJECT_REQUEST = "FETCH_PROJECT_REQUEST";
export const FETCH_PROJECT_REQUEST_SUCCESS = "FETCH_PROJECT_REQUEST_SUCCESS";
export const FETCH_PROJECT_REQUEST_FAILED = "FETCH_PROJECT_REQUEST_FAILED";

export const UPDATE_PROJECT_REQUEST = "UPDATE_PROJECT_REQUEST";
export const UPDATE_PROJECT_REQUEST_SUCCESS = "UPDATE_PROJECT_REQUEST_SUCCESS";
export const UPDATE_PROJECT_REQUEST_FAILED = "UPDATE_PROJECT_REQUEST_FAILED";
